import type { AnalyticsFiltersGroup } from '../components/AnalyticsFilterSelect/AnalyticsFiltersSelect.types'

export const isAnyFilterActive = (
  currentFilters: AnalyticsFiltersGroup[],
  initialFilters: AnalyticsFiltersGroup[],
): boolean => {
  if (currentFilters.length !== initialFilters.length) {
    return true
  }

  return currentFilters.some((section, sectionIndex) => {
    const initialSection = initialFilters[sectionIndex]
    if (section.title !== initialSection.title) {
      return true
    }

    if (section.items.length !== initialSection.items.length) {
      return true
    }

    return section.items.some((item, itemIndex) => {
      const initialItem = initialSection.items[itemIndex]

      return item.value !== initialItem.value || item.checked !== initialItem.checked
    })
  })
}
